import React, { Component, Fragment } from 'react'
import LazyYouTube from '../../LazyYouTube/LazyYouTube'
import Picture from '../../Picture'

import './TestimonialCardStarsDistributor.scss'

const aiTestimonialsData = [
  {
    testimonial: <Fragment>"Acabei seguindo o mesmo processo que usava ao adicionar por planilha, porque é mais cômodo. O mais incrível é que a ferramenta permite alterar a quantidade de uma referência, caso esteja errada, já no momento da importação, sem precisar ficar ajustando a planilha várias vezes. <b>Simplesmente perfeito!</b>"</Fragment>,
    author: "Kaio Azevedo",
    company: "WKF Representações",
    stars: 5,
  },
  {
    testimonial: <Fragment>"Bem legal! Otimiza bastante o tempo para as empresas que recebem muitos pedidos pelo WhatsApp e perdem tempo criando tudo manualmente. Com a IA, é só copiar e colar a mensagem e, se for necessário, ajustar algum item. <b>É rápido, simples e muito eficiente.</b>"</Fragment>,
    author: "Eduardo Woiciechoski",
    company: "WB Distribuidora",
    stars: 5,
  },
  {
    testimonial: <Fragment>"<b>Tem sido bem útil mesmo!</b> O que mais notei de diferença foi o tempo que tenho economizado. Antes eu ficava muito tempo fazendo pedidos que recebo por e-mail ou whatsapp manualmente, tendo que colocar número exato de cada produto, e agora com a IA isso ficou muito mais rápido.</Fragment>,
    author: "Bruno Barbosa",
    company: "Barbosa & Colombi",
    stars: 5,
  }
];

const homeTestimonialsData = [
  {
    testimonial: <Fragment>Fazíamos várias reuniões presenciais com grandes contas e precisávamos registrar rapidamente pedidos com muitos itens, em grandes quantidades. Levávamos bastante tempo para concluir tudo. Hoje, com o Pedidos com IA, a emissão ficou muito mais ágil. O Mercos tem uma tecnologia que realmente facilita nosso dia a dia.</Fragment>,
    author: "Jéssica Araujo",
    company: "Océane",
    stars: 5,
    img: "jessica-araujo",
    imgAlt: "Jéssica Araujo, Océane"
  },
  {
    testimonial: <Fragment>A facilidade do cliente fazer os pedidos conosco foi o principal ponto. Ficamos extremamente felizes em saber que nossos clientes, gostam, se adaptam bem e não têm dificuldades. É tudo muito simples, interativo e fácil de usar. O sistema é muito completo e facilita muito a nossa vida!</Fragment>,
    author: "Alessandro Gonçalves",
    company: "Diretor Comercial da Mels Brushes",
    stars: 5,
    img: "alessandro-goncalves",
    imgAlt: "Alessandro Gonçalves, Diretor Comercial da Mels Brushes"
  },
  {
    testimonial: <Fragment><b>Aumento de 20% do faturamento com o e-commerce B2B</b><br/><br/>Evoluímos na qualidade dos pedidos, desde a maneira que a gente entrega o pedido pras empresas como na maneira com que a gente gera os pedidos.</Fragment>,
    author: "Henrique Zompeiro",
    company: "Gerente Financeiro na CorsaBIke",
    stars: 5,
    img: "henrique-zompeiro",
    imgAlt: "Henrique Zompeiro, Gerente Financeiro na CorsaBike"
  }
];

class TestimonialVideoCards extends Component {
    constructor(props) {
        super(props);
    }

    getTestimonials() {
        const testimonialList = {
            joseDavidCopelman: {
                img: "jose-david-copelman",
                imgAlt: "José David Copelman, Gestor Nacional de Vendas na CROWN",
                title: "Crescimento de 12% em vendas em 2023",
                testimonial: <Fragment>Antes do Mercos, eram 3 pessoas exclusivas para lançar pedidos. Hoje com os dois sistemas integrados, <strong>ganhamos controle e eficiência em nossa operação</strong>.</Fragment>,
                author: "José David Copelman",
                company: "Gestor Nacional de Vendas na CROWN",
            },
            leandroCampos: {
                img: "leandro-campos",
                imgAlt: "Leandro Campos, Gestor Comercial e Marketing na Tagima",
                testimonial: <Fragment>Nossos clientes têm uma primeira experiência positiva, pois o E-commerce B2B é tão intuitivo e fácil de usar quanto o Força de vendas. O principal ganho foi a velocidade na tratativa de pedidos. Agora, conseguimos processar mais notas por dia e, até mesmo, integrar estoque.</Fragment>,
                author: "Leandro Campos",
                company: "Gestor Comercial e Marketing na Tagima",
            },
            henriqueZompeiroOld: {
                img: "henrique-zompeiro",
                imgAlt: "Henrique Zompeiro, Gerente Financeiro na CorsaBike",
                title: "Aumento de 20% do faturamento com o e-commerce B2B",
                testimonial: <Fragment>Evoluímos na qualidade dos pedidos, desde a maneira que a gente entrega o pedido pras empresas como na maneira com que a gente gera os pedidos.</Fragment>,
                author: "Henrique Zompeiro",
                company: "Gerente Financeiro na CorsaBike",
                className: "desktop-only"
            },
            allanGomes: {
                img: "allan-gomes",
                imgAlt: "Allan Gomes, Sócio proprietário da La Ganexa",
                title: "O Mercos economizou 2 dias de trabalho mensal que tínhamos antes",
                testimonial: <Fragment>Além de trazer economia de tempo e eficiência para o nosso processo, também trouxe mais dinheiro para a La Ganexa.</Fragment>,
                author: "Allan Gomes",
                company: "Sócio proprietário da La Ganexa",
            },
            felipeAlmeida: {
                img: "felipe-almeida",
                imgAlt: "Felipe Almeida, HPrime",
                testimonial: <Fragment>Hoje, os vendedores estão muito mais focados na relação com o cliente e em serem especialistas que ajudam na venda e no pós-venda do que em resolver as minúcias burocráticas de uma tabela, por exemplo</Fragment>,
                author: "Felipe Almeida",
                company: "HPrime",
            },
            alexandreSantos: {
                img: "alexandre-santos-delicia-lanches",
                imgAlt: "Alexandre Santos, Delícia Lanches",
                testimonial: <Fragment>Imagine a nossa felicidade em ganhar produtividade, se adaptar ao mercado e às tendências. Não tem jeito, quem não faz isso perde grandes oportunidades.</Fragment>,
                author: "Alexandre Santos",
                company: "Delícia Lanches",
                className: "desktop-only"
            },
            francielMartins: {
                img: "franciel-martins",
                imgAlt: "Franciel Martins",
                testimonial: <Fragment>O Mercos transformou completamente nossa operação de vendas. A facilidade de uso e a integração com nossos sistemas existentes nos permitiu aumentar significativamente nossa produtividade.</Fragment>,
                author: "Franciel Martins",
                company: "Empresa Demo",
            },
            francielMartins2: {
                img: "franciel",
                imgAlt: "Franciel Martins, ZT Representações",
                testimonial: <Fragment>O Mercos pra gente foi um divisor de águas na questão da operação. Evoluímos na qualidade dos pedidos, desde a maneira que a gente entrega o pedido pras empresas como na maneira com que a gente gera e monta os pedidos.</Fragment>,
                author: "Franciel Martins",
                company: "ZT Representações",
            },
            joaoDePauloOliveira: {
                img: "joao-paulo-oliveira",
                imgAlt: "João de Paulo Oliveira, Gao Cosméticos",
                testimonial: <Fragment>Eu pesquisei soluções de mercado e decidi contratar Mercos porque a ferramenta além de ser fácil de usar, me oferece três recursos que meu negócio precisa: e-commerce B2B, força de vendas e indicadores gerenciais</Fragment>,
                author: "João de Paulo Oliveira",
                company: "Gao Cosméticos",
            },
        };

        // Return testimonials based on props
        if (this.props.tpPage) {
            return [
                testimonialList.francielMartins2,
                testimonialList.felipeAlmeida,
                testimonialList.joaoDePauloOliveira
            ];
        }

        return [
            testimonialList.leandroCampos,
            testimonialList.felipeAlmeida,
            testimonialList.alexandreSantos
        ];
    }

    defaultTestimonials() {
        const { isAI, isHome, title: sectionTitle, descriptionH4, isAIPage, noVideo, tpPage, customTestimonials: customTestimonialsProp, isDistributor } = this.props;
        // Prefer explicit customTestimonials passed via props (page-specific overrides)
        const baseTestimonials = isAI ? aiTestimonialsData : isHome ? homeTestimonialsData : [];
        const customTestimonials = Array.isArray(customTestimonialsProp) && customTestimonialsProp.length > 0
            ? customTestimonialsProp
            : (tpPage ? this.getTestimonials() : []);
        const testimonialsToRender = customTestimonials.length > 0 ? customTestimonials : baseTestimonials;

        const TitleComponent = isAIPage ? 'h3' : 'h3';
        const containerClass = isDistributor ? 'static-testimonials static-testimonials-distributor' : 'static-testimonials static-testimonials-b2b';

        return (
            <div className={containerClass}>
                <div className={`testimonials-title ${sectionTitle ? 'testimonials-title-picture-second-title' : ''}`} >
                    <div className="testimonials-title-slider-btns">
                        {sectionTitle ?
                            <TitleComponent className='title'>{sectionTitle}</TitleComponent> : ''
                        }
                    </div>
                </div>
                
                {!noVideo && (
                    <div className="testimonials-videos">
                        <div className="container">
                            {isAIPage ? (
                                <Fragment>
                                    <div className="video"><iframe loading="lazy" width="300" height="550" src="https://www.youtube.com/embed/hg8RE2ebBKw" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe></div>
                                    <div className="video desktop"><iframe loading="lazy" width="300" height="550" src="https://www.youtube.com/embed/GbkxUaWZYJw" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe></div>
                                    <div className="video"><iframe loading="lazy" width="300" height="550" src="https://www.youtube.com/embed/oBLU1_LOL3A" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe></div>
                                </Fragment>
                            ) : isAI ? (
                                <Fragment>
                                    <div className="video"><iframe loading="lazy" width="300" height="550" src="https://www.youtube.com/embed/hg8RE2ebBKw" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe></div>
                                    <div className="video desktop"><iframe loading="lazy" width="300" height="550" src="https://www.youtube.com/embed/GbkxUaWZYJw" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe></div>
                                    <div className="video"><iframe loading="lazy" width="300" height="550" src="https://www.youtube.com/embed/oBLU1_LOL3A" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe></div>
                                </Fragment>
                            ) : isHome ? (
                                <Fragment>
                                    <div className="video"><LazyYouTube videoId="6qEule4v-b8" coverImage="/images/site/depoimentos/alessandro-vertical-video.png" title="Depoimento Alessandro" /></div>
                                    <div className="video desktop"><LazyYouTube videoId="kF5GQkz6J6w" coverImage="/images/site/depoimentos/bruno-vertical-video.png" title="Depoimento Bruno" /></div>
                                    <div className="video"><LazyYouTube videoId="9Z2o648HcBw" coverImage="/images/site/depoimentos/rafael-vertical-video.png" title="Depoimento Rafael" /></div>
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <div className="video"><iframe loading="lazy" width="300" height="550" src="https://www.youtube.com/embed/FHnSkFs8Xmg?si=Nuatrl8SzhFXIDbK&controls=0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe></div>
                                    <div className="video desktop-only"><iframe loading="lazy" width="300" height="550" src="https://www.youtube.com/embed/eFgUXUQdq2M?si=TaKxCao1DPTKKGXa&controls=0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe></div>
                                    <div className="video"><iframe loading="lazy" width="300" height="550" src="https://www.youtube.com/embed/6qEule4v-b8?si=6TnmqyVB8SGDlz-t&controls=0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe></div>
                                </Fragment>
                            )}
                        </div>
                    </div>
                )}

                {testimonialsToRender && testimonialsToRender.length > 0 ? (
                    <div className="testimonial-cards-container">
                        {testimonialsToRender.map((testimonial, index) => (
                            <div key={index} className={`testimonial-card ${testimonial.className || ''}`}>
                                <div className="testimonial-card-head">
                                    {testimonial.categoryIcon ? (
                                        <div className="testimonial-category-badge">
                                            <div className="category-icon">
                                                <Picture src={testimonial.categoryIcon} alt="" />
                                            </div>
                                            <span className="testimonial-category-text">{testimonial.categoryText}</span>
                                        </div>
                                    ) : (
                                        <span className="testimonial-card-stars">{'★'.repeat(testimonial.stars || 5)}</span>
                                    )}
                                </div>
                                {testimonial.title && (
                                    <p className="testimonial-card-title">{testimonial.title}</p>
                                )}
                                <p className='testimonial-card-paragraph'>
                                    {testimonial.testimonial}
                                </p>
                                <div className="testimonial-card-header">
                                    <div className="testimonial-card-author-company">
                                        {testimonial.img && (
                                            <Picture className='profile-image' alt={testimonial.imgAlt} width="50" src={`/images/site/depoimentos/${testimonial.img}.png`} />
                                        )}
                                        <div className="testimonial-author-wrapper">
                                            <p className='testimonial-card-author'>{testimonial.author}</p>
                                            <p className='testimonial-card-company'>{testimonial.company}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : null}
            </div>
        )
    }

    repsTestimonials() {
        return <div className="static-testimonials">Reps Testimonials (Not Implemented with AI prop yet)</div>;
    }

    blacknovTestimonials() {
        return <div className="static-testimonials">Black November Testimonials (Not Implemented with AI prop yet)</div>;
    }

    render() {
        return (
            <Fragment>
                {this.props.reps ? this.repsTestimonials() : this.props.blackNovember ? this.blacknovTestimonials() : this.defaultTestimonials()}
            </Fragment>
        )
    }
}
export default TestimonialVideoCards



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/TestimonialCardStars/TestimonialVideoCards.jsx